import { useEffect } from 'react';
import { compareObjects } from '../functions/utils/comapareObjects';
import { KeyboardData, useKeyboardStore } from './stores/keyboardStore';
import { UIData, useUIStore } from './stores/uiStore';
import { useScene } from '../context/sceneContext';

type Shortcut = {
  keys: string[];
  onPress?: () => void;
  onRelease?: () => void;
};

export const keyboardHooks = () => {
  const scene = useScene();
  const [keyboardData] = useKeyboardStore<KeyboardData>();
  const [UIData, setUIData] = useUIStore<UIData>();

  const shortcuts: Shortcut[] =
    UIData.editorMode === 'simulation'
      ? [
          {
            keys: ['Space'],
            onPress: () => setUIData({ editorMode: 'simulation' }),
            onRelease: () => setUIData({ editorMode: 'editing' }),
          },
          // Save
          {
            keys: ['KeyS'],
            onPress: () => {
              scene.saveThemeVersion();
            },
          },
          {
            keys: ['ControlLeft', 'KeyS'],
            onPress: () => {
              scene.saveThemeVersion();
            },
          },
        ]
      : [
          {
            keys: ['Escape'],
            onPress: () => setUIData({ selectedElementIDs: [] }),
          },
          {
            keys: ['Space'],
            onPress: () => setUIData({ editorMode: 'simulation' }),
            onRelease: () => setUIData({ editorMode: 'editing' }),
          },
          {
            keys: ['Delete'],
            onPress: () => scene.deleteSelectedElements(),
          },
          {
            keys: ['Backspace'],
            onPress: () => scene.deleteSelectedElements(),
          },
          // Save
          {
            keys: ['KeyS'],
            onPress: () => {
              scene.saveThemeVersion();
            },
          },
          {
            keys: ['ControlLeft', 'KeyS'],
            onPress: () => {
              scene.saveThemeVersion();
            },
          },

          // History undo
          {
            keys: ['KeyZ'],
            onPress: () => scene.historyUndo(),
          },
          {
            keys: ['ControlLeft', 'KeyZ'],
            onPress: () => scene.historyUndo(),
          },
          {
            keys: ['MetaLeft', 'KeyZ'],
            onPress: () => scene.historyUndo(),
          },
          // History redo
          {
            keys: ['KeyY'],
            onPress: () => scene.historyRedo(),
          },
          {
            keys: ['ControlLeft', 'KeyY'],
            onPress: () => scene.historyRedo(),
          },
          {
            keys: ['ShiftLeft', 'KeyZ'],
            onPress: () => scene.historyRedo(),
          },
          // Duplicate
          {
            keys: ['KeyD'],
            onPress: () => scene.duplicateSelectedElements(),
          },
          {
            keys: ['ControlLeft', 'KeyD'],
            onPress: () => scene.duplicateSelectedElements(),
          },
          // Copy
          {
            keys: ['KeyC'],
            onPress: () => scene.copySelectedElements(),
          },
          {
            keys: ['ControlLeft', 'KeyC'],
            onPress: () => scene.copySelectedElements(),
          },
          // Paste
          {
            keys: ['KeyV'],
            onPress: () => scene.pasteElements(),
          },
          {
            keys: ['ControlLeft', 'KeyV'],
            onPress: () => scene.pasteElements(),
          },
          // Cut
          {
            keys: ['KeyX'],
            onPress: () => {
              scene.copySelectedElements();
              scene.deleteSelectedElements();
            },
          },
          {
            keys: ['ControlLeft', 'KeyX'],
            onPress: () => {
              scene.copySelectedElements();
              scene.deleteSelectedElements();
            },
          },
          // Toggle panels
          {
            keys: ['Digit1'],
            onPress: () =>
              setUIData({
                openModalIDs: UIData.openModalIDs.includes(
                  'advancedLauncherStatesPanel'
                )
                  ? UIData.openModalIDs.filter(
                      (id) => id !== 'advancedLauncherStatesPanel'
                    )
                  : [...UIData.openModalIDs, 'advancedLauncherStatesPanel'],
              }),
          },
          {
            keys: ['Digit2'],
            onPress: () =>
              setUIData({
                openModalIDs: UIData.openModalIDs.includes(
                  'advancedElementInfoPanel'
                )
                  ? UIData.openModalIDs.filter(
                      (id) => id !== 'advancedElementInfoPanel'
                    )
                  : [...UIData.openModalIDs, 'advancedElementInfoPanel'],
              }),
          },
          // Toggle position guides
          {
            keys: ['KeyG'],
            onPress: () =>
              setUIData({
                showAbsoluteGuides: !UIData.showAbsoluteGuides,
                showRelativeGuides: !UIData.showRelativeGuides,
              }),
          },
        ];

  useEffect(() => {
    shortcuts.forEach((shortcut) => {
      const isPressed = compareObjects(keyboardData.keysDown, shortcut.keys);
      const isReleased = compareObjects(keyboardData.keysUp, shortcut.keys);

      if (isPressed) shortcut.onPress?.();
      if (isReleased) shortcut.onRelease?.();
    });
  }, [keyboardData]);
};
